// Helper function to format date for section headers
export function formatDateHeader(date: Date): string {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const messageDate = new Date(date);
    messageDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);

    if (messageDate.getTime() === today.getTime()) {
        return 'Today';
    } else if (messageDate.getTime() === yesterday.getTime()) {
        return 'Yesterday';
    } else {
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        });
    }
}

/**
 * Determines if a message should be treated as a system message based on its parts.
 * System messages are those that only contain tool-related parts (tool invocations, step markers)
 * and no text content from the assistant.
 */
export function isSystemMessage(
    parts: Array<{ type: string; text?: string; toolInvocation?: any }>
): boolean {
    if (!parts || parts.length === 0) {
        return false;
    }

    // Check if all parts are tool-related or empty text
    const systemPartTypes = ['tool-invocation', 'step-start', 'step-end'];

    for (const part of parts) {
        // If it's a text part with actual content, it's not a system message
        if (part.type === 'text' && part.text && part.text.trim().length > 0) {
            return false;
        }

        // If it's not a text part and not a system part type, it's not a system message
        if (part.type !== 'text' && !systemPartTypes.includes(part.type)) {
            return false;
        }
    }

    // Must have at least one tool-related part to be considered a system message
    return parts.some((part) => systemPartTypes.includes(part.type));
}
